import React from 'react'
import RoundedDropdown from '../../../Component/BasicComponents/Dropdowns/RoundedDropdown'
import RouteDropdown from '../../../Component/BasicComponents/Dropdowns/RouteDropdown'
import { Label } from 'reactstrap'



export default function AccountInformation() {
  return (
    <div style={{backgroundColor:'#fff',padding:'15px'}}>
      <Label style={{fontSize:20,fontWeight:'600'
      }}>Account Details</Label>
     <div className="row mb-3">
        <div className="col-md-4">
          <label style={{ fontWeight: "500", marginTop: "8px" }}>
            Bank Name
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Bank Name"
            value={''}
            onChange={(e) => console.log(e.target.value)}
          />
        </div>
        <div className="col-md-4">
          <label style={{ fontWeight: "500", marginTop: "8px" }}>
            Account Number
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Account Number"
            value={''}
            onChange={(e) => console.log(e.target.value)}
          />
        </div>
          <div className="col-md-4">
          <label style={{ fontWeight: "500", marginTop: "8px" }}>
            Payment Method
          </label>
           <RouteDropdown
            options={[]}
            onChange={()=>{}}
            // width="fit-content"
            // isShowHeading={false}
            // headingColor="#2e8dd3"
          />
          </div>
        </div>
        </div>
  )
}